import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

export function useBuscadorGlobal() {
    const [open, setOpen] = useState(false);
    const [query, setQuery] = useState('');
    const [resultados, setResultados] = useState([]);
    const [loading, setLoading] = useState(false);
    const inputRef = useRef(null);
    const navigate = useNavigate();

    // Atajos de teclado
    useEffect(() => {
        const handleKeyDown = (e) => {
            if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
                e.preventDefault();
                setOpen(true);
            }
            if (e.key === 'Escape' && open) setOpen(false);
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [open]);

    // Auto-focus y limpieza
    useEffect(() => {
        if (open) {
            setTimeout(() => inputRef.current?.focus(), 100);
        } else {
            setQuery('');
            setResultados([]);
        }
    }, [open]);

    // Búsqueda predictiva (Debounce)
    useEffect(() => {
        if (query.length < 2) {
            setResultados([]);
            return;
        }
        const buscar = async () => {
            setLoading(true);
            try {
                const res = await api.get(`/pacientes?search=${encodeURIComponent(query)}&limit=5`);
                setResultados(Array.isArray(res) ? res : []);
            } catch (error) {
                console.error('Error en búsqueda global:', error);
                setResultados([]);
            } finally {
                setLoading(false);
            }
        };

        const timeout = setTimeout(buscar, 300);
        return () => clearTimeout(timeout);
    }, [query]);

    const handleSelect = (pacienteId) => {
        setOpen(false);
        navigate(`/pacientes/${pacienteId}`);
    };

    return {
        open, setOpen,
        query, setQuery,
        resultados, loading,
        inputRef, handleSelect
    };
}